import { stringToNumber } from 'util/stringToNumber';
import styled, { keyframes } from 'styled-components';
import { REACTION_FADE_OUT_DURATION } from '../../consts';

const slideUp = keyframes`
    0% {
        transform: translate3d(0, 0, 0);
    }
    100% {
        transform: translate3d(0, -70vh, 0);
    }
`;

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

const fadeOut = keyframes`
    0% {
        opacity: 1;
    }
    92% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
`;

export const AnimatedReactionsContainer = styled.div`
    position: fixed;
    left: 0;
    bottom: 80px;
    width: 50%;
    min-width: 200px;
    max-width: 600px;
    height: calc(100vh - 80px);
    pointer-events: none;
    z-index: 100;
    padding-left: 24px;
    padding-right: 80px;
    overflow: hidden;
    will-change: contents;
    contain: strict;

    @media (max-width: 768px) {
        width: 80%;
        max-width: 80%;
        padding-right: 48px;
    }
`;

interface AnimatedReactionProps {
    $offsetX: number;
    $isFading?: boolean;
}

export const AnimatedReaction = styled.div<AnimatedReactionProps>`
    position: absolute;
    bottom: 0;
    left: ${(props) => `${props.$offsetX}px`};
    opacity: ${(props) => (props.$isFading ? 0 : 1)};
    transition: opacity ${REACTION_FADE_OUT_DURATION}ms ease-out;
`;

export const AnimatedReactionInner = styled.div<{ $delay: number }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    backface-visibility: hidden;
    will-change: transform, opacity;
    transform: translate3d(0, 0, 0);
    contain: layout style paint;
    animation: ${fadeIn} 0.4s ease-out, ${slideUp} 5s linear forwards, ${fadeOut} 5s linear forwards;
    animation-delay: 0ms, ${(props) => `${props.$delay}ms`}, ${(props) => `${props.$delay}ms`};
`;

export const ReactionEmoji = styled.span`
    font-size: 50px;
    line-height: 1;
    flex-shrink: 0;
`;

export const LottieCanvas = styled.canvas.attrs({
    width: 60,
    height: 80,
})`
    display: block;
    width: 60px;
    height: 80px;
`;

interface ParticipantNameBubbleProps {
    participantId: string;
}

export const ParticipantNameBubble = styled.span<ParticipantNameBubbleProps>`
    font-size: 13px;
    line-height: 14px;
    display: inline-block;
    max-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
    color: ${(props) => props.theme.root.colors.basicColors.white['100%']};
    padding: 3px 6px;
    border-radius: 19px;
    background: ${({ participantId, theme }) => {
        return theme.getAvatarColorsById(stringToNumber(participantId)).background;
    }};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    margin-top: 4px;

    @media (max-width: 768px) {
        max-width: 140px;
    }
`;
